import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Col, Form, FormGroup, Label, ModalFooter, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { hotelConfigSelector } from "./hotelConfigSlice";
import { editHotel, fetchHotelConfig } from "./api";
import { toast } from "react-toastify";

const Messages = () => {
  const dispatch = useDispatch();

  const { hotelConfigData, isLoading, status } =
    useSelector(hotelConfigSelector);
  console.log("isLoading:", isLoading);
  console.log("status:", status);
  console.log("hotelConfigData:", hotelConfigData);

  useEffect(() => {
    dispatch(fetchHotelConfig());
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => {
      return hotelConfigData;
    }, [hotelConfigData]),
  });

  const functionCB = (data) => {
    if (data.success == true) {
      return toast.success(data.result?.message || "Successful");
    } else if (data.success == false) {
      return toast.error(
        data.result?.message ||
          "Oops.. Something went wrong Please try again later"
      );
    }
  };

  const onSubmit = (data) => {
    console.log(data);
    if (hotelConfigData) {
      dispatch(editHotel({ ...data, CB: functionCB }));
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
        <Row>
          <Col>
            <FormGroup>
              <Label>{"CheckIn Required Msg:"}</Label>
              <textarea
                className="form-control"
                name="checkInRequiredMsg"
                {...register("checkInRequiredMsg", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.checkIn_required_msg &&
                  "CheckIn required msg is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Diffrent User For ASSAABLOY Message:"}</Label>
              <textarea
                className="form-control"
                name="diffrentUserForASSAABLOYMessage"
                {...register("diffrentUserForASSAABLOYMessage", {
                  required: true,
                })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.guarantee_policy && "Guarantee policy is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"FeedBack Alert Msg:"}</Label>
              <textarea
                className="form-control"
                name="feedBackAlertMsg"
                {...register("feedBackAlertMsg", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.pets_policy && "Pets policy is required"}
              </span>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label>{"Meeting Cancellation Policy:"}</Label>
              <textarea
                className="form-control"
                name="meetingCancellationPolicy"
                {...register("meetingCancellationPolicy", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.loyalty_text && "About hotel URL is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Remove Card Warning Msg:"}</Label>
              <textarea
                className="form-control"
                name="removeCardWarning"
                {...register("removeCardWarning", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.personalisation && "Personalisation is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Logout With Key Available Msg:"}</Label>
              <textarea
                className="form-control"
                name="logoutWithKeyAvailableText"
                {...register("logoutWithKeyAvailableText", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.profile_setup && "Profile setup is required"}
              </span>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>{"Delete user conditions Msg:"}</Label>
              <textarea
                className="form-control"
                name="DeleteUserConditionsText"
                {...register("DeleteUserConditionsText", { required: true })}
              />
              <span style={{ color: "#ff5370" }}>
                {errors.profile_setup && "Profile setup is required"}
              </span>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <ModalFooter>
              <Btn
                attrBtn={{
                  color: "primary",
                  // onClick: props.togglerSave,
                }}
              >
                SaveChanges
              </Btn>
            </ModalFooter>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Messages;
